export const environment = {
  staging: false,
  hmr:false,
  netevia:true,
  production: false,
  recaptchaV2SiteKey: '6Lcr9iUsAAAAAMXw_Hrr4at_is_gjRlD-19k8e7P',
  recaptchaV3SiteKey: '6LcG-yUsAAAAAEaw-wgOmKgOujrCdg-iPuKUEiFn',
};
